(function () {
  function injectGuardForm() {
    var sections = document.querySelectorAll('.m6pr, .m6pr-compact');
    for (var i = 0; i < sections.length; i++) {
      var sec = sections[i];
      if (sec.querySelector('form.f8pr')) continue;
      var f = document.createElement('form');
      f.className = 'f8pr cart-initialized';
      f.hidden = true;
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('data-axion-variant-fix', '');
      f.style.display = 'none';
      sec.appendChild(f);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectGuardForm);
  } else {
    injectGuardForm();
  }
})();